import React, { useEffect, useMemo, useRef, useState } from 'react';
import checkVideoType from '../../../../../utilites/checkVideoType';
import { Input, InputGroupErrorRow, InputGroupWrapper, LinkError, PreviewWrapper, PreviewAudioWrapper, ProjectEditFormGridRow, ProjectEditPageGridLabel, ErrorDescription, VideoEditRoot } from './styles';
import ReactPlayer from 'react-player';
import AudioPost from '../../postblocks/audioblock';
import useLocalization from '../../../../../hooks/useLocalization';
import KinescopePlayer from '@kinescope/react-kinescope-player';
import { getKinescopeVideoId } from '../../../../../utilites/getKinescopeVideoId';
var MediaInputGroup = function (_a) {
    var value = _a.value, onSubmit = _a.onSubmit, style = _a.style;
    var t = useLocalization().t;
    var _b = useState(value), text = _b[0], setText = _b[1];
    var _c = useState(null), videoType = _c[0], setVideoType = _c[1];
    var _d = useState(null), errorKey = _d[0], setErrorKey = _d[1];
    var debounceTimer = useRef();
    var vkPreview = useMemo(function () {
        if (text) {
            var s = ((text === null || text === void 0 ? void 0 : text.match(/src="(.*?)"/)) && (text === null || text === void 0 ? void 0 : text.match(/src="(.*?)"/)[1])) || null;
            var h = ((text === null || text === void 0 ? void 0 : text.match(/height="\s*(\d+)"/)) &&
                (text === null || text === void 0 ? void 0 : text.match(/height="\s*(\d+)"/)[1])) ||
                null;
            var w = ((text === null || text === void 0 ? void 0 : text.match(/width="\s*(\d+)"/)) &&
                (text === null || text === void 0 ? void 0 : text.match(/width="\s*(\d+)"/)[1])) ||
                null;
            if (s && w && h) {
                return (React.createElement("iframe", { width: 320, height: 180, scrolling: 'no', frameBorder: 'no', allow: 'autoplay', src: s }));
            }
        }
    }, [videoType, text]);
    useEffect(function () {
        setText('');
        setErrorKey(null);
    }, [style]);
    var handleChange = function (_a) {
        var value = _a.target.value;
        setText(value);
        if (errorKey) {
            setErrorKey(null);
        }
    };
    var resetTimer = function () {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
            debounceTimer.current = null;
        }
    };
    var handleSubmit = function (e) {
        if (e) {
            e.preventDefault();
        }
        var type = checkVideoType(text);
        var audioIframeCheck = text.match(/<iframe\s+.*?\s+src=(".*?").*?<\/iframe>/);
        setVideoType(type);
        if (style === 'audio' &&
            (['v', 'yt', 'nodata', 'vk'].includes(type) || audioIframeCheck === null)) {
            setErrorKey('editor.unknown_types.audio');
        }
        else if (style === 'video' && ['s', 'nodata'].includes(type)) {
            setErrorKey('editor.unknown_types.video');
        }
        else {
            onSubmit(text);
        }
    };
    useEffect(function () {
        if (text) {
            resetTimer();
            debounceTimer.current = setTimeout(function () {
                handleSubmit();
            }, 500);
        }
        return function () {
            resetTimer();
        };
    }, [text]);
    return (React.createElement(VideoEditRoot, { onSubmit: handleSubmit },
        React.createElement(ProjectEditFormGridRow, null,
            React.createElement(ProjectEditPageGridLabel, null, t("editor.paste_".concat(style))),
            React.createElement(InputGroupWrapper, null,
                React.createElement(Input, { className: 'media-input', value: text, onChange: handleChange, placeholder: t("editor.placeholders.".concat(style)) }))),
        errorKey && (React.createElement(InputGroupErrorRow, null,
            React.createElement(ProjectEditPageGridLabel, null),
            React.createElement(LinkError, null, t(errorKey)))),
        errorKey && style === 'video' && (React.createElement(ProjectEditFormGridRow, { offsetTop: 16 },
            React.createElement(ProjectEditPageGridLabel, null),
            React.createElement(ErrorDescription, null,
                React.createElement("p", null, t('error.vk_error')),
                React.createElement("p", null, t('error.rutube_error')),
                React.createElement("p", null, t('error.successful_copying_error'))))),
        value && style === 'video' && !errorKey && (React.createElement(ProjectEditFormGridRow, { offsetTop: 24 },
            React.createElement(ProjectEditPageGridLabel, null),
            React.createElement(PreviewWrapper, null, videoType === 'ksc' ? (React.createElement(KinescopePlayer, { width: 320, height: 180, videoId: getKinescopeVideoId(value) })) : ['vk', 'rt'].includes(videoType) ? (vkPreview) : (React.createElement(ReactPlayer, { url: value, width: 320, height: 180, controls: true }))))),
        value && style === 'audio' && (React.createElement(ProjectEditFormGridRow, { offsetTop: 24 },
            React.createElement(ProjectEditPageGridLabel, null),
            React.createElement(PreviewAudioWrapper, null,
                React.createElement(AudioPost, { post: { text: text } }))))));
};
export default MediaInputGroup;
//# sourceMappingURL=MediaInputGroup.js.mapimport React, { useEffect, useMemo, useRef, useState } from 'react';
import checkVideoType from '../../../../../utilites/checkVideoType';
import { Input, InputGroupErrorRow, InputGroupWrapper, LinkError, PreviewWrapper, PreviewAudioWrapper, ProjectEditFormGridRow, ProjectEditPageGridLabel, ErrorDescription, VideoEditRoot } from './styles';
import ReactPlayer from 'react-player';
import AudioPost from '../../postblocks/audioblock';
import useLocalization from '../../../../../hooks/useLocalization';
import KinescopePlayer from '@kinescope/react-kinescope-player';
import { getKinescopeVideoId } from '../../../../../utilites/getKinescopeVideoId';
var MediaInputGroup = function (_a) {
    var value = _a.value, onSubmit = _a.onSubmit, style = _a.style;
    var t = useLocalization().t;
    var _b = useState(value), text = _b[0], setText = _b[1];
    var _c = useState(null), videoType = _c[0], setVideoType = _c[1];
    var _d = useState(null), errorKey = _d[0], setErrorKey = _d[1];
    var debounceTimer = useRef();
    var vkPreview = useMemo(function () {
        if (text) {
            var s = ((text === null || text === void 0 ? void 0 : text.match(/src="(.*?)"/)) && (text === null || text === void 0 ? void 0 : text.match(/src="(.*?)"/)[1])) || null;
            var h = ((text === null || text === void 0 ? void 0 : text.match(/height="\s*(\d+)"/)) &&
                (text === null || text === void 0 ? void 0 : text.match(/height="\s*(\d+)"/)[1])) ||
                null;
            var w = ((text === null || text === void 0 ? void 0 : text.match(/width="\s*(\d+)"/)) &&
                (text === null || text === void 0 ? void 0 : text.match(/width="\s*(\d+)"/)[1])) ||
                null;
            if (s && w && h) {
                return (React.createElement("iframe", { width: 320, height: 180, scrolling: 'no', frameBorder: 'no', allow: 'autoplay', src: s }));
            }
        }
    }, [videoType, text]);
    useEffect(function () {
        setText('');
        setErrorKey(null);
    }, [style]);
    var handleChange = function (_a) {
        var value = _a.target.value;
        setText(value);
        if (errorKey) {
            setErrorKey(null);
        }
    };
    var resetTimer = function () {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
            debounceTimer.current = null;
        }
    };
    var handleSubmit = function (e) {
        if (e) {
            e.preventDefault();
        }
        var type = checkVideoType(text);
        var audioIframeCheck = text.match(/<iframe\s+.*?\s+src=(".*?").*?<\/iframe>/);
        setVideoType(type);
        if (style === 'audio' &&
            (['v', 'yt', 'nodata', 'vk'].includes(type) || audioIframeCheck === null)) {
            setErrorKey('editor.unknown_types.audio');
        }
        else if (style === 'video' && ['s', 'nodata'].includes(type)) {
            setErrorKey('editor.unknown_types.video');
        }
        else {
            onSubmit(text);
        }
    };
    useEffect(function () {
        if (text) {
            resetTimer();
            debounceTimer.current = setTimeout(function () {
                handleSubmit();
            }, 500);
        }
        return function () {
            resetTimer();
        };
    }, [text]);
    return (React.createElement(VideoEditRoot, { onSubmit: handleSubmit },
        React.createElement(ProjectEditFormGridRow, null,
            React.createElement(ProjectEditPageGridLabel, null, t("editor.paste_".concat(style))),
            React.createElement(InputGroupWrapper, null,
                React.createElement(Input, { className: 'media-input', value: text, onChange: handleChange, placeholder: t("editor.placeholders.".concat(style)) }))),
        errorKey && (React.createElement(InputGroupErrorRow, null,
            React.createElement(ProjectEditPageGridLabel, null),
            React.createElement(LinkError, null, t(errorKey)))),
        errorKey && style === 'video' && (React.createElement(ProjectEditFormGridRow, { offsetTop: 16 },
            React.createElement(ProjectEditPageGridLabel, null),
            React.createElement(ErrorDescription, null,
                React.createElement("p", null, t('error.vk_error')),
                React.createElement("p", null, t('error.rutube_error')),
                React.createElement("p", null, t('error.successful_copying_error'))))),
        value && style === 'video' && !errorKey && (React.createElement(ProjectEditFormGridRow, { offsetTop: 24 },
            React.createElement(ProjectEditPageGridLabel, null),
            React.createElement(PreviewWrapper, null, videoType === 'ksc' ? (React.createElement(KinescopePlayer, { width: 320, height: 180, videoId: getKinescopeVideoId(value) })) : ['vk', 'rt'].includes(videoType) ? (vkPreview) : (React.createElement(ReactPlayer, { url: value, width: 320, height: 180, controls: true }))))),
        value && style === 'audio' && (React.createElement(ProjectEditFormGridRow, { offsetTop: 24 },
            React.createElement(ProjectEditPageGridLabel, null),
            React.createElement(PreviewAudioWrapper, null,
                React.createElement(AudioPost, { post: { text: text } }))))));
};
export default MediaInputGroup;
//# sourceMappingURL=MediaInputGroup.js.map